class DatabaseService {
  constructor(baseUrl = '/api') {
    this.baseUrl = baseUrl;
  }

  async request(endpoint, body = {}) {
    try {
      const credentials = AWS.config.credentials;
      
      const request = new AWS.HttpRequest(`${this.baseUrl}${endpoint}`, 'ap-southeast-2');
      request.method = 'POST';
      request.body = JSON.stringify(body);
      request.headers['Content-Type'] = 'application/json';
      request.headers['Host'] = new URL(`${this.baseUrl}${endpoint}`).host;
      
      const signer = new AWS.Signers.V4(request, 'execute-api');
      signer.addAuthorization(credentials, new Date());
      
      const response = await fetch(`${this.baseUrl}${endpoint}`, {
        method: request.method,
        headers: request.headers,
        body: request.body
      });
      
      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }
      
      return response.json();
    } catch (err) {
      console.error('Database request failed:', err);
      throw err;
    }
  }

  collection(name) {
    return new Collection(name, this);
  }
}

class Collection {
  constructor(name, db) {
    this.name = name;
    this.db = db;
  }

  async find(query = {}, options = {}) {
    const { sort, limit, skip, ...projection } = options;
    return this.db.request(`${this.name}/read`, {
      operation_type: 'bulk',
      filter: query,
      ...(Object.keys(projection).length && { projection }),
      ...(sort && { sort: Object.entries(sort) }),
      ...(limit && { limit }),
      ...(skip && { skip })
    });
  }

  async count(query = {}) {
    return this.db.request(`${this.name}/count`, { 
      filter: query 
    });
  }

  async insertOne(doc) {
    return this.db.request(`${this.name}/create`, {
        operation_type: 'atomic',
        document: doc
    });
  }

  async updateOne(filter, update) {
    return this.db.request(`${this.name}/update`, {
        operation_type: 'atomic',
        filter,
        update
    });
  }

  async deleteOne(filter) {
    return this.db.request(`${this.name}/delete`, {
        operation_type: 'atomic',
        filter
    });
  }
}

const getApiStage = () => {
  const hostname = window.location.hostname;
  return (hostname === 'localhost' || hostname.includes('dev.')) ? 'test' : 'prod';
};

export default new DatabaseService(`https://rkn22akwp8.execute-api.ap-southeast-2.amazonaws.com/${getApiStage()}/`);